import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DashboardContentWrapperComponent } from '../components/dashboard-content-wrapper/dashboard-content-wrapper.component';
import { FooterComponent } from './../components/footer/footer.component';
import { NgModule } from '@angular/core';
import { UploaderFromExcelComponent } from '../components/uploader-from-excel/uploader-from-excel.component';
import { DevExtremeModule } from './devExtreme.module';
import { OrderModule } from 'ngx-order-pipe';
// import { NullWithDefaultPipe } from '../pipe/null-with-default.pipe';
import { OrderByPipe } from '../pipe/order-by.pipe';
import { ProgrammeComponent } from '../components/programme/programme.component';
import { PulseLoadingComponent } from '../components/pulse-loading/pulse-loading.component';
import { HolidayEventReasonComponent } from '../components/holiday-event-reason/holiday-event-reason.component';
import { AddHolidayModalComponent } from '../components/add-holiday-modal/add-holiday-modal.component';
import { DayOverrideModalComponent } from '../components/day-override-modal/day-override-modal.component';
import { CloneModalComponent } from '../components/clone-modal/clone-modal.component';
import { EditHolidayModalComponent } from '../components/edit-holiday-modal/edit-holiday-modal.component';
@NgModule({
  imports: [
    DevExtremeModule,
    OrderModule,
    RouterModule,
    CommonModule,
    FormsModule,
  ],
  declarations: [
    UploaderFromExcelComponent,
    FooterComponent,
    DashboardContentWrapperComponent,
    OrderByPipe,
    ProgrammeComponent,
    PulseLoadingComponent,
    HolidayEventReasonComponent,
    AddHolidayModalComponent,
    DayOverrideModalComponent,
    CloneModalComponent,
    EditHolidayModalComponent,
    // NullWithDefaultPipe
  ],
  exports: [
    UploaderFromExcelComponent,
    FooterComponent,
    DashboardContentWrapperComponent,
    ProgrammeComponent,
    PulseLoadingComponent,
    HolidayEventReasonComponent,
    AddHolidayModalComponent,
    DayOverrideModalComponent,
    CloneModalComponent,
    EditHolidayModalComponent,
  ],
})
export class SharedModule {}
